import React, { Component } from "react";

class Troubleshooting extends Component {
  render() {
    return (
      <div>
        <p>
          The SmartConsole Extensions framework intercepts console logs from
          your extension and print them in the SmartConsole log file.
        </p>
        <ol>
          <li>
            <h4>Enable Debug Logs.</h4>
          </li>
          <p>
            Go to Manage &amp; Settings &gt; Preferences &gt; Start Debugging
          </p>

          <p>
            <b>Note,</b> In Multi Domain Management, go to Multi Domain &gt;
            Preferences &gt; Start Debugging.
          </p>

          <li>
            <h4>
              Debug Logs Location.{" "}
              <img
                src="assets/info.svg"
                alt="info"
                style={{ verticalAlign: "bottom" }}
                title="SmartConsole GA logs are printed to SmartConsole.log file"
              />
            </h4>
          </li>
          <p>
            Local Deployment – The log file is located at [
            <b>Installation Path</b>]\Output\ExtensionsBrowser.log.
          </p>
          <p>
            SmartConsole Installation - The log file will be found at [
            <b>Local User</b>]\AppData\Local\Check Point\SmartConsole\[
            <b>Installed Version</b>]\ExtensionsBrowser.log.
          </p>

          <li>
            <h4>Debug Logs Structure.</h4>
          </li>
          <p>Intercepted console logs are in the following format:</p>
          <p>
            BrowserDisplayHandler – [<b>Extension Source</b>]([<b>Line</b>]):[
            <b>Message</b>]
          </p>
        </ol>
      </div>
    );
  }
}

export default Troubleshooting;
